export  const progressColors = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
  };

 export const bgColors = {
    success: '#e6f4ea',
    error: '#fdecea',
    warning: '#fff4e5',
    info: '#e8f0fe',
  };

 export const textColors = {
    success: '#2e7d32',
    error: '#d32f2f',
    warning: '#ed6c02',
    info: '#0288d1',
  };
